if (!customElements.get('sticky-header')) {
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.headerInner = this.querySelector('[data-header-desktop], [data-header-mobile]');
    if (!this.headerInner) return;

    this.parentSection = this.closest('.shopify-section');
    if (!this.parentSection) return;

    this.stickyType = this.getAttribute('data-sticky-type');
    if (this.stickyType === 'none') return;

    this.headerIsAlwaysSticky = this.stickyType === 'always';
    this.headerBounds = {};

    this.setHeaderHeight();

    if (this.headerIsAlwaysSticky) {
      this.parentSection.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    this.createObserver();
  }

  setHeaderHeight() {
    const resizeObserver = new ResizeObserver(() => {
      if (this.headerInner.offsetHeight > 0) {
        document.documentElement.style.setProperty(
          '--header-height',
          `${this.headerInner.offsetHeight}px`
        );
      }
    });
    resizeObserver.observe(this.headerInner);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        this.headerBounds = entries[0].intersectionRect;
      },
      { threshold: [0] }
    );
    observer.observe(this);
  }

  onScroll() {
    requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.parentSection.classList.add('scrolled-past-header');
        this.headerInner.classList.add('is-sticky');
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.parentSection.classList.add('scrolled-past-header');
        this.headerInner.classList.add('is-sticky');

        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.parentSection.classList.remove('scrolled-past-header');
        this.headerInner.classList.remove('is-sticky');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    });
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.parentSection.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosures();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.parentSection.classList.remove('shopify-section-header-hidden');
    this.parentSection.classList.add('shopify-section-header-sticky', 'animate');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.parentSection.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosures() {
    const disclosures = this.querySelectorAll('header-menu, details[open]');
    disclosures.forEach((d) => {
      if (typeof d.close === 'function') d.close();
      else if (d.tagName === 'DETAILS') d.open = false;
    });
  }
}

customElements.define('sticky-header', StickyHeader);
}